import { useContext, useEffect, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import { AlertContext } from '../contexts/AlertContext';
import { useHistory, useParams } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Storage } from 'aws-amplify';
import eyewear from '../productTemplates/eyewear.json';

export const AddProductPage = (params) => {
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const { dispatch } = useContext(AlertContext);
  const closeAlert = () => dispatch({ type: 'close' }); // HACK: needed to pass reducer dispatch() func
  const { collection, productType, productSKU } = useParams();
  const [newProduct, setNewProduct] = useState({
    collection,
    productType,
    productId: null,
    sku: null,
    displaySKU: null,
    brand: null,
    productLine: null,
    name: null,
    price: null,
    description: null,
    productURL: null,
  });
  const [collectionProducts, setCollectionProducts] = useState({});
  const [key, setKey] = useState('add');
  const productTemplates = {eyewear};

  useEffect(() => {
    Storage.get(`p/${collection}/products.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          const collectionProducts = JSON.parse(resText);
          setCollectionProducts(collectionProducts);
        });
      })
      .catch((err) => console.warn(err));
  }, [collection, productSKU]);

  const handleChange = (e) => {
    const key = e.target.id;
    let value = e.target.value;
    // make SKU all lowercase only
    if (key === 'sku') {
      value = value.toLowerCase().replace(/[^0-9a-z]/gi, '');
    }
    setNewProduct({...newProduct, [key]: value});
  };

  const writeJSON = async (object, s3Path, onSuccess) => {
    try {
      await Storage.remove(s3Path);
      const res = await Storage.put(s3Path, JSON.stringify(object, null, 2), {
        level: 'public',
        contentType: 'application/json',
        cacheControl: 'no-cache',
      });
      console.log('New Product Added:', res?.key);
      dispatch({
        type: 'success',
        title: 'New Product Added',
        message: `New product created and saved.`,
        onConfirm: () => {closeAlert(); if (onSuccess) { onSuccess(); }},
      });
    } catch (err) {
      console.warn('S3 write Error:', err);
      dispatch({
        type: 'danger',
        title: 'New Product NOT Added',
        message: `ERROR: ${err}.`,
        onConfirm: closeAlert,
      });
    }
  };

  const handleSubmit = () => {
    const newProductSKU = newProduct.sku;
    // add product type if it doesn't exist
    if (collectionProducts.productTypes.includes(productType) === false) {
      collectionProducts.productTypes.push(productType);
      collectionProducts[productType] = { productSKUs: [] };
    }
    // XXX: add new SKU if it doesn't exist
    // first don't write if no new SKU has been entered
    if (typeof newProductSKU === 'undefined' || newProductSKU === null || newProductSKU === '') {
      dispatch({
        type: 'danger',
        title: 'New Product NOT Added',
        message: `ERROR: Please add a valid product SKU`,
        onConfirm: closeAlert,
      });
    // also don't write if no productId has been eneterd
    } else if (typeof newProduct.productId === 'undefined' || newProduct.productId === null || newProduct.productId === '') {
      dispatch({
        type: 'danger',
        title: 'New Product NOT Added',
        message: `ERROR: Please add a valid FaceCake productID`,
        onConfirm: closeAlert,
      });
      // also don't write if the SKU already exist
    } else if (
      collectionProducts[productType].productSKUs.includes(newProductSKU)
    ) {
      dispatch({
        type: 'danger',
        title: 'New Product NOT Added',
        message: `ERROR: Product ${newProductSKU} Already Exists`,
        onConfirm: closeAlert,
      });
      // else write if it doesn't exist
    } else {
      // first create the folders
      const folders = ['assets', 'images', 'media', 'metadata', 'model'];
      folders.map(async (folder) => {
        await Storage.put(`p/${collection}/${newProductSKU}/${folder}/`, null, {
          level: 'public',
        });
      });
      // next create and upload the metadata JSON files from productTemplates
      if (productTemplates?.[productType]) {
        const productTemplate = productTemplates[productType];
        const configTypes = Object.keys(productTemplates[productType]);
        // first update each config type from newProduct
        configTypes.forEach((configType) => {
          const thisConfig = productTemplate[configType];
          const newProductKeys = Object.keys(newProduct);
          const thisConfigKeys = Object.keys(thisConfig);
          thisConfigKeys.forEach((configKey) => {
            if (newProductKeys.includes(configKey)) {
              thisConfig[configKey] = newProduct[configKey];
            }
          });
          writeJSON(
            thisConfig,
            `p/${collection}/${newProductSKU}/metadata/${configType}`,
            () =>
              history.push(
                `/product/${collection}/${productType}/${newProductSKU}`
              )
          );
        });
      }
      // finally update the products.json file for the collection
      collectionProducts[productType].productSKUs.push(newProductSKU);
      writeJSON(collectionProducts, `p/${collection}/products.json`, () =>
        history.push(`/product/${collection}/${productType}/${newProductSKU}`)
      );
    }
  };

  return (
    <Container fluid className="px-1 px-sm-1">
      <Row className="px-1 px-sm-3">
        <Col xs={12} className="px-1 px-sm-3">
          <Breadcrumb>
            <Breadcrumb.Item href={`/products/${collection}`}>
              {collection.toUpperCase()}
            </Breadcrumb.Item>
            <Breadcrumb.Item href={`/products/${collection}/${productType}`}>
              {productType.toUpperCase()}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>ADD NEW PRODUCT</Breadcrumb.Item>
          </Breadcrumb>

          <Tabs
            id="product-metadata-tabs"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="add"
              disabled
              title={
                <span>
                  Add <span className="d-none d-sm-inline">New Product</span>
                </span>
              }
            >
              <Container>
                <Row>
                  <Col>
                    <br />
                    <Card>
                      <Card.Header
                        style={{
                          backgroundColor: 'var(--secondary-light)',
                        }}
                      >
                        PRODUCT DETAIL
                      </Card.Header>
                      <Card.Body>
                        <Form>
                          <Form.Group as={Row} controlId="collection" className="mb-3">
                            <Form.Label column sm={3}>
                              Collection
                            </Form.Label>
                            <Col>
                              <Form.Control
                                type="text"
                                placeholder="Enter collection name"
                                value={newProduct.collection || ''}
                                readOnly={true}
                                onChange={handleChange}
                              />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="productType" className="mb-3">
                            <Form.Label column sm={3}>
                              Product Type
                            </Form.Label>
                            <Col>
                              <Form.Control
                                type="text"
                                placeholder="Enter product type"
                                value={newProduct.productType || ''}
                                readOnly={true}
                                onChange={handleChange}
                              />
                            </Col>
                          </Form.Group>

                          {[
                            'sku',
                            'displaySKU',
                            'productId',
                            'productViewId',
                            'brand',
                            'productLine',
                            'name',
                            'price',
                            'description',
                            'productURL',
                          ].map((field) => (
                            <Form.Group as={Row} key={field} controlId={field}
                            className={field === 'sku' ? 'mb-0' : 'mb-3'}>
                              <Form.Label column sm={3}>
                                {field === 'sku' ? (
                                  <span>
                                    Product SKU{' '}
                                    <br/><small>(lcase alphnumeric only)</small>
                                  </span>
                                ) : (
                                  field.charAt(0).toUpperCase() + field.slice(1)
                                )}
                              </Form.Label>
                              <Col>
                                <Form.Control
                                  type="text"
                                  placeholder={`Enter ${field}`}
                                  value={newProduct[field] || ''}
                                  onChange={handleChange}
                                />
                              </Col>
                            </Form.Group>
                          ))}

                          <Form.Row className="float-right">
                            <Button variant={'primary'} onClick={handleSubmit}>
                              Add New Product
                            </Button>
                          </Form.Row>
                        </Form>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </Tab>
            <Tab
              eventKey="metadata"
              disabled
              title={
                <span>
                  <span className="d-none d-sm-inline">Product</span> Metadata
                </span>
              }
            ></Tab>
            <Tab
              eventKey="web"
              disabled
              title={
                <span>
                  Web <span className="d-none d-sm-inline">Asset</span>
                </span>
              }
            ></Tab>
            {authState?.userGroups?.includes('facecake/admin') && (
              <Tab
                eventKey="ios"
                disabled
                title={
                  <span>
                    iOS <span className="d-none d-sm-inline">Asset</span>
                  </span>
                }
              ></Tab>
            )}
            {authState?.userGroups?.includes('facecake/admin') && (
              <Tab
                eventKey="android"
                disabled
                title={
                  <span>
                    Android <span className="d-none d-sm-inline">Asset</span>
                  </span>
                }
              ></Tab>
            )}
          </Tabs>
        </Col>
      </Row>
    </Container>
  );
};
